import { Role } from "src/services/user/role.enum";
import { Maybe } from "src/services/utils/type.utils";

export enum HowDidYouHearAboutUs {
  blog = "blog",
  digitalAdvertising = "digitalAdvertising",
  foundYourSuvsOrEmployees = "foundYourSuvsOrEmployees",
  googleSearch = "googleSearch",
  hotelConcierge = "hotelConcierge",
  other = "other",
  referralFromFriendsOrFamily = "referralFromFriendsOrFamily",
  socialMedia = "socialMedia",
}

export interface User {
  company?: string;
  createdAt?: any;
  email: string;
  firstName: string;
  hasActiveSubscription?: boolean;
  hasMissingPayment?: boolean;
  howDidYouHearAboutUs?: HowDidYouHearAboutUs;
  id: string;
  lastName: string;
  overseer?: string;
  phone: string;
  providerId?: string;
  pushToken?: string;
  role: Role;
  stripeId?: string;
  tags?: string[];
  updatedAt?: Date;
}

export interface UserAdditionalData {
  company?: string;
  firstName: Maybe<string>;
  lastName: Maybe<string>;
  phoneNumber: Maybe<string>;
  providerId: Maybe<string>;
}

export const placeholderName = "User without name";

export function userHasDefaultName(firstName: string | undefined, lastName: string | undefined): boolean {
  if (!firstName || !lastName) {
    return false;
  }

  return `${firstName.trim()} ${lastName.trim()}`.toLowerCase() === placeholderName.toLowerCase();
}

export function userToString(user: User | undefined): string {
  if (!user) {
    return "No user found";
  }

  if (!user.firstName && !user.lastName) {
    return placeholderName;
  }

  return `${user.firstName ?? ""} ${user.lastName ?? ""}`;
}

export function isUser(input: object): input is User {
  return "email" in input && "firstName" in input && "lastName" in input;
}
